export const BRAILLER_STATUS = {
    Available: 0,
    CheckedOut: 1,
    Reserved: 2,
    Damaged: 3,
    Lost: 4,
    InRepair: 5,
    Retired: 6,
};